import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta(
    "页面不存在-奇优影院",
    "你访问的页面不存在或已被移动，可以返回奇优影院首页继续浏览电影、电视剧与影视资讯。",
    "奇优影院",
  );

  return (
    <SiteLayout>
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <p className="text-5xl md:text-7xl font-extrabold font-heading text-primary-200">404</p>
        <h1 className="text-xl md:text-2xl font-extrabold text-foreground-950 font-heading mt-3">
          这个页面不在片单里
        </h1>
        <p className="text-sm text-foreground-600 mt-2">
          我们找不到 <span className="text-foreground-900">{location.pathname}</span> 对应的内容，不如去看看正在热映的片子。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <Link
            to="/"
            className="h-10 px-4 inline-flex items-center rounded-md bg-primary-700 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="h-10 px-4 inline-flex items-center rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            电影分类
          </Link>
          <Link
            to="/category/tv"
            className="h-10 px-4 inline-flex items-center rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            电视剧分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}